<template>
  <div class="symposium_video">
    <div class="symposium_video-banner">
      <picture>
        <source
          srcset="@/assets/images/symposium/banner_2025.webp"
          type="image/webp"
        />
        <source
          srcset="@/assets/images/symposium/banner_2025.png"
          type="image/png"
        />
        <img
          src="@/assets/images/symposium/banner_2025.png"
          alt="Symposium cover"
          class="symposium_video-banner-image"
        />
      </picture>
    </div>
    <div class="container">
      <div>
        <div
          v-if="isRoomLoading"
          class="symposium_video-input_select-loading"
        ></div>
        <InputSelect
          v-else
          :isLoading="isRoomLoading"
          :list="roomList"
          :defaultId="roomIdSelect"
          @change="handleChangeRoom"
        />
      </div>

      <div v-if="symposiums.length === 0">
        <div v-for="index in 1" :key="index">
          <h2 class="symposium_video-date_text" style="visibility: hidden;">
            Loading...
          </h2>
          <hr class="symposium_video-date_line" />
          <article>
            <section class="ssss" v-for="indexCard in 5" :key="indexCard">
              <CardSymposiumVideo :isLoadingMode="true" />
            </section>
          </article>
        </div>
      </div>
      <div v-else>
        <div v-for="(symposium, index) in symposiums" :key="index">
          <h2
            class="symposium_video-date_text"
            :style="{ 'margin-top': index != 0 ? '100px' : '0' }"
          >
            {{ moment(symposium.date).format("ddd D MMMM YYYY") }}
          </h2>
          <hr class="symposium_video-date_line" />
          <article>
            <section
              v-for="(talk, index) in symposium.data"
              :key="index"
              v-show="talk.is_active_symposium"
            >
              <router-link :to="`/symposium/video/${talk.id}`">
                <CardSymposiumVideo
                  :name="talk.name"
                  :coverImage="
                    `${baseURL}/storage/app/img/symposium/${talk.video_thumbnail}`
                  "
                  :nameImage="
                    `${baseURL}/storage/app/img/symposium/${talk.title_image}`
                  "
                  :timeRange="talk.time_start + '-' + talk.time_end"
                  :speakers="talk.thumbnail_speaker"
                />
              </router-link>
            </section>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { constantsComputed } from '@/store/helpers'

export default {
  components: {
    InputSelect: () => import('@/components/Inputs/Select'),
    CardSymposiumVideo: () => import('@/components/Cards/SymposiumVideo')
  },

  data () {
    return {
      symposiumListFilter: {
        page: 0,
        pageLimit: 9999999,
        sort: 'asc',
        sortBy: 'date',
        roomName: '',
        topicTalkId: 2
      },
      roomListFilter: {
        page: 0,
        pageLimit: 9999999
      },
      roomIdSelect: null,
      roomList: []
    }
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      rooms: state => state.symposium.rooms,
      symposiums: state => state.symposium.symposiums
    }),

    isRoomLoading () {
      if (
        this.rooms.length === 0 &&
        this.roomList.length === 0 &&
        this.roomIdSelect === null
      ) {
        return true
      } else {
        return false
      }
    }
  },

  methods: {
    moment,

    setRoomList () {
      if (this.rooms.length !== 0) {
        if (
          this.rooms.length > 0 &&
          sessionStorage.getItem('symposium_room_id_selected')
        ) {
          this.roomIdSelect = parseInt(
            sessionStorage.getItem('symposium_room_id_selected')
          )
          this.symposiumListFilter.roomName = this.rooms.find(
            room => room.id === this.roomIdSelect
          ).name
        } else {
          this.roomIdSelect = this.rooms[0].id
          this.symposiumListFilter.roomName = this.rooms[0].name
        }

        const excludeIds = [4, 5, 8, 9]

        this.rooms.forEach(room => {
          if (!excludeIds.includes(room.id)) {
            this.roomList.push({
              id: room.id,
              name: room.name
            })
          }
        })

        this.$store.dispatch('symposium/getList', this.symposiumListFilter)
      }
    },

    handleChangeRoom (id) {
      this.roomIdSelect = id
      this.symposiumListFilter.roomName = this.rooms.find(
        x => x.id === id
      ).name

      this.$store.dispatch('symposium/getList', this.symposiumListFilter)

      sessionStorage.setItem('symposium_room_id_selected', this.roomIdSelect)
    }
  },

  created () {
    this.$store.dispatch('symposium/getRoomList', this.roomListFilter)

    this.setRoomList()
  },

  beforeDestroy () {
    this.$store.dispatch('symposium/defaultList')
    this.$store.dispatch('symposium/defaultRoom')
  },

  watch: {
    rooms () {
      this.setRoomList()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.symposium_video {
  &-banner {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #c7c7c5;

    &-image {
      max-height: 450px;
      height: 450px;

      @media only screen and (max-width: $break-l) {
        width: 100%;
        height: unset;
      }
    }
  }

  &-input_select {
    &-loading {
      @include skeleton;
      width: 450px;
      height: 36px;
      border-radius: 4px;
    }
  }

  &-date_text {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 2rem;
    color: #000000;
  }

  &-date_line {
    margin-top: 0;
    margin-bottom: 38px;
    width: 100%;
    height: 1px;
    background-color: #c6c6c6;
  }
}
</style>
